import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { request, handleRequestErrors } from '../helpers/Requests'
import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';

import { capitalize, adminUser, managerUser, setIdAndMethod, renderErrorWarning, renderErrors, hideElementForNonAdminsAndNonManagers } from '../utilities/Forms.js'
import { debounce, getContrastYIQ } from '../utilities/Generic.js'
import Audits from '../components/shared/Audits';

class ServiceForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreateServiceCategory = this.handleCreateServiceCategory.bind(this);
    this.handleNewStaffBreak = this.handleNewStaffBreak.bind(this);
    this.handleUpdateStaffBreak = this.handleUpdateStaffBreak.bind(this);
    this.handleRemoveStaffBreak = this.handleRemoveStaffBreak.bind(this);
  }

  state = {
    name: "",
    color_hex: "#EE2290",
    color: "#EE2290",
    text_color: "black",
    default_price: "",
    duration: "",
    staff_breaks: [],
    hidden: false,
    person_ids: [],
    partial: "",

    page: 1,
    slotLength: null,
    people: [],

    service_category_id: "",
    service_categories: [],
    createServiceCategoryModal: false,
    newServiceCategoryName: "",

    loaded: false,
    slotLengthLoaded: false,
    peopleLoaded: false,
    serviceCategoriesLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    this.setState({[name]: value});
  }

  handleColorChange(event) {
    let value = event.target.value;

    this.setState({color_hex: value});
    if (this.validateHexColor(value)) {
      this.setState({
        invalidColor: false,
        color: value,
        text_color: getContrastYIQ(value)
      })
    }
    else {
      this.setState({ invalidColor: true })
    }
  }

  validateHexColor(string) {
    if (string && string.length === 7 && string[0] === "#" && this.hexValidator(string)) {
      return true
    }
  }

  hexValidator(string) {
    const validCharacters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"]
    for (let index in string) {
      if (index === "0") {
        continue
      }

      if (!validCharacters.includes(string[index].toUpperCase())) {
        return false
      }
    }
    return true
  }

  handleMultiCheckbox(event) {
    let name = parseInt(event.target.name);
    let value = event.target.checked;

    var person_ids = this.state.person_ids

    if (value === true) {
      if (!person_ids.includes(name)) {
        person_ids.push(name)
      }
    }
    else if (value === false) {
      if (person_ids.includes(name)) {
        let index = person_ids.indexOf(name)
        person_ids.splice(index, 1)
      }
    }

    this.setState({person_ids: person_ids});
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      page: 1
    });

    this.debouncedHandlePersonSearch(value, 1)
  }

  handleNextPage(event) {
    let page = parseInt(this.state.page) + 1

    this.setState(prevState => ({
      page: page,
      people: [],
      peopleLoaded: false
    }))

    this.handlePersonSearch(this.state.partial, page)

    event.preventDefault();
  }

  handlePreviousPage(event) {
    let page = parseInt(this.state.page) - 1

    this.setState(prevState => ({
      page: page,
      people: [],
      peopleLoaded: false
    }))

    this.handlePersonSearch(this.state.partial, page)

    event.preventDefault();
  }

  handlePersonSearch(partial, page) {
    request('GET', `/v1/a/people/scoped_names_and_ids?person[type][]=staff&person[type][]=contractor&person[partial]=${partial}&page=${page}}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        handleRequestErrors(this, error, { peopleLoaded: true })
      })
  }

  handleNewStaffBreak(event) {
    this.setState(prevState => ({
      staff_breaks: [...prevState.staff_breaks, { name: "", start: '', end: '' }]
    }));

    event.preventDefault()
  }

  handleUpdateStaffBreak(event) {
    let index = event.target.parentNode.parentNode.id;
    let name = event.target.name;
    let value = event.target.value;

    this.setState((prevState) => {
      let staff_breaks = [...prevState.staff_breaks]
      staff_breaks[index][name] = value

      return { staff_breaks: staff_breaks }
    });
  }

  handleRemoveStaffBreak(event) {
    let index = event.currentTarget.id;

    this.setState((prevState) => {
      let staff_breaks = [...prevState.staff_breaks]
      staff_breaks.splice(index, 1)

      return { staff_breaks: staff_breaks }
    })

    event.preventDefault();
  }

  handleSubmit(event) {
    this.setState({updating: true})

    const json = JSON.stringify({
      "service": {
        "name": this.state.name,
        "color": this.state.color,
        "default_price": this.state.default_price,
        "duration": this.state.duration,
        "staff_breaks": this.state.staff_breaks,
        "hidden": this.state.hidden,
        "person_ids": this.state.person_ids,
        "service_category_id": this.state.service_category_id
      }
    })

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/services/${id}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Service ${this.props.mode}d successfully!`);

        if (this.props.mode === "create") {
          this.setState({ id: data.id, redirect: true })
        }
        else if (this.props.mode === "update") {
          this.props.closeEditPanel()
        }
      })
      .catch(error => {
        handleRequestErrors(this, error, { updating: false })
      })

    event.preventDefault();
  }

  renderDurationInput(slotLength) {
    if (!slotLength) {
      return <input className="column" type="number" min="0" step="any" name="duration" value={this.state.duration} onChange={this.handleChange} />
    }

    return (
      <select name="duration" value={this.state.duration} onChange={this.handleChange}>
        <option value="">Select a duration</option>
        {this.state.durationOptions}
      </select>
    )
  }

  renderServiceCategoryInput() {
    const { service_category_id, service_categories } = this.state;

    return (
      <div>
        <select name="service_category_id" value={service_category_id} onChange={this.handleChange}>
          <option value="">Unassigned</option>
          {service_categories.map((category) => (
            <option key={category.id} value={category.id}>{category.name}</option>
          ))}
        </select>
      </div>
    )
  }

  renderPageButtons(page) {
    if (this.state.people.length < 250 && page === 1) {
      return ""
    }
    else {
      return (
        <div className="page-button-container">
          <button className="button new-button" onClick={this.handlePreviousPage} disabled={parseInt(page) < 2}>Previous Page</button>
          <button className="button new-button" onClick={this.handleNextPage} disabled={this.state.people.length <= 249}>Next Page</button>
        </div>
      )
    }
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  closeModal(event) {
    this.setState({
      createServiceCategoryModal: false,
      newServiceCategoryName: ""
    })
    event.preventDefault()
  }

  openModal(event) {
    this.setState({
      createServiceCategoryModal: true,
      newServiceCategoryName: ""
    })
    event.preventDefault()
  }

  handleCreateServiceCategory(event) {
    const json = JSON.stringify({
      "service_category": {
        "name": this.state.newServiceCategoryName
      }
    })

    request('POST', `/v1/a/service_categories`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState(prevState => ({
          service_categories: [...prevState.service_categories, {id: data.id, name: prevState.newServiceCategoryName}],
          service_category_id: data.id,
          createServiceCategoryModal: false,
          newServiceCategoryName: ""
        }))
      })
      .catch(error => {
        handleRequestErrors(this, error, { errors: {service_category_name: error.name} })
      })

    event.preventDefault()
  }

  renderCreateServiceCategoryModal() {
    if (this.state.createServiceCategoryModal) {
      return (
        <div className="modal-container always-on-top">
          <div className="modal-content no-overflow">
            <label className="column">New Service Category Name:</label>{ renderErrors(this.state.errors, 'service_category_name') }
            <input className="value" name="newServiceCategoryName" value={this.state.newServiceCategoryName} onChange={this.handleChange} />
            <button className="modal-button" onClick={this.closeModal}>Cancel</button>
            <button className="modal-button new-button" onClick={this.handleCreateServiceCategory}>Create</button>
          </div>
        </div>
      )
    }
  }

  render() {
    const { name, color_hex, color, text_color, default_price, duration, staff_breaks, hidden, person_ids, serviceCategoriesLoaded, partial, people, slotLength, id, loaded, redirect, peopleLoaded, page, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/configuration/services/${id}`}/>
    }

    if (loaded === false || peopleLoaded === false || serviceCategoriesLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const title = this.props.mode === "create" ? "New" : "Edit"
      const formatName = name ? ` ${name} | ` : ""

      return (
        <div>
          <SetTitle title={`${title} Service | ${formatName}Services`} />

          <form onSubmit={this.handleSubmit}>
            <div className="settings big-settings">
              <div className="row">
                <HelpText page={'services'} section={'name'} />

                <label className="column">Service Name:</label>{ renderErrors(errors, 'name') }
                <input className="column" type="text" name="name" value={name} onChange={this.handleChange} />
              </div>

              <div className="row">
                <HelpText page={'services'} section={'color'} />

                <label className="column">Service Colour:</label>{ renderErrors(errors, 'color') }
                <input className="column" type="text" name="color" value={color_hex} onChange={this.handleColorChange} />

                <label>Choose a default colour:</label>
                <div className="default-color-options">
                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#B80C09" value="#B80C09" checked={color === "#B80C09"} onChange={this.handleColorChange} />
                    <label htmlFor="#B80C09" style={{ backgroundColor: "#B80C09", color: "white" }}>Red</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#FF8819" value="#FF8819" checked={color === "#FF8819"} onChange={this.handleColorChange} />
                    <label htmlFor="#FF8819" style={{ backgroundColor: "#FF8819", color: "black" }}>Orange</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#EEE622" value="#EEE622" checked={color === "#EEE622"} onChange={this.handleColorChange} />
                    <label htmlFor="#EEE622" style={{ backgroundColor: "#EEE622", color: "black" }}>Yellow</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#22EE80" value="#22EE80" checked={color === "#22EE80"} onChange={this.handleColorChange} />
                    <label htmlFor="#22EE80" style={{ backgroundColor: "#22EE80", color: "black" }}>Green</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#222AEE" value="#222AEE" checked={color === "#222AEE"} onChange={this.handleColorChange} />
                    <label htmlFor="#222AEE" style={{ backgroundColor: "#222AEE", color: "white" }}>Blue</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#8826BF" value="#8826BF" checked={color === "#8826BF"} onChange={this.handleColorChange} />
                    <label htmlFor="#8826BF" style={{ backgroundColor: "#8826BF", color: "white" }}>Violet</label>
                  </div>

                  <div className="default-color-option fulfilment">
                    <input className="column" type="radio" name="color" id="#EE2290" value="#EE2290" checked={color === "#EE2290"} onChange={this.handleColorChange} />
                    <label htmlFor="#EE2290" style={{ backgroundColor: "#EE2290", color: "white" }}>Magenta</label>
                  </div>
                </div>
                <div className="fulfilment preview padding-bottom">
                  <label>Service colour preview:</label>
                  <div className="role-title"><div className="role-preview-color" style={{ backgroundColor: color, color: text_color }}>{name}</div></div>
                </div>
              </div>

              <div className="row">
                <HelpText page={'services'} section={'default_price'} />

                <label className="column">Price:</label>{ renderErrors(errors, 'default_price') }
                <input className="column" type="number" min="0" step="any" name="default_price" value={default_price} onChange={this.handleChange} />
              </div>

              <div className="row">
                <HelpText page={'services'} section={'hidden'} />

                <input className="column" type="checkbox" name="hidden" id="hidden_checkbox" checked={hidden} onChange={this.handleCheckbox} />
                <label className="column checkbox-label" htmlFor="hidden_checkbox">Hidden?</label>{ renderErrors(errors, 'hidden') }
              </div>
            </div>

            <div className="settings big-settings">
              <div className="row">
                <HelpText page={'services'} section={'duration'} />

                <label className="column">Duration in minutes:</label>{ renderErrors(errors, 'duration') }
                {this.renderDurationInput(slotLength)}
              </div>

              <div className="row">
                <HelpText page={'services'} section={'staff_breaks'} />

                <label className="column">Staff Breaks:</label>{ renderErrors(errors, 'staff_breaks') }

                <div className="table big-table small-text">
                  <div className="tr heading">
                    <div className="th">Name</div>
                    <div className="th">Start</div>
                    <div className="th">End</div>
                    <div className="th">Remove</div>
                  </div>
                  {staff_breaks.map((staff_break, index) =>
                    <div className="tr" key={index} id={index}>
                      <div className="td">
                        <input type="text" name="name" value={staff_break.name} onChange={this.handleUpdateStaffBreak} />
                      </div>
                      <div className="td">
                        <input className="really-short-input" type="number" name="start" min="0" max={duration} value={staff_break.start} onChange={this.handleUpdateStaffBreak} /> minutes in
                      </div>
                      <div className="td">
                        <input className="really-short-input" type="number" name="end" min="0" max={duration} value={staff_break.end} onChange={this.handleUpdateStaffBreak} /> minutes in
                      </div>
                      <div className="td center">
                        <div className="button small-button" id={index} onClick={this.handleRemoveStaffBreak}>Remove</div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="long-tr center" style={{backgroundColor: "#fff"}}>
                  <div className="long-td">
                    <div className="button" onClick={this.handleNewStaffBreak}>Add {staff_breaks.length > 0 ? "another" : "a"} staff break +</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="settings big-settings">
              <div className="row">
                {this.renderCreateServiceCategoryModal()}
                <HelpText page={'services'} section={'service_category'} />

                <label className="column">Service Category:</label>{ renderErrors(errors, 'service_category') }
                {this.renderServiceCategoryInput()}
                <Link to={`#`} onClick={this.openModal}>
                  <div className={`button new-button negative-top-margin ${hideElementForNonAdminsAndNonManagers()}`}>Create New</div>
                </Link>
              </div>
            </div>

            <div className="settings big-settings">
              <div className="row">
                <HelpText page={'services'} section={'people'} />

                <label className="column">Assign Staff:</label>{ renderErrors(errors, 'person') }

                <div className="scroll-box">
                  <div className="search-box">
                    <input name="partial" placeholder="Enter text to search" className="search-text" onChange={this.handlePartialChange} value={partial} />

                    <div className="scrollable-table">
                      <table className="checkbox-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Existing Service</th>
                            <th>Assigned</th>
                          </tr>
                        </thead>
                        <tbody>
                          {people.map((person) => (
                            <tr key={person.id}>
                              <td>
                                <Link to={`/people/${person.id}`}>{person.full_name}</Link>
                              </td>
                              <td>
                                {capitalize(person.type_of_person)}
                              </td>
                              <td>
                                {person.services.map((service) => (
                                  <Link key={service.id} to={`/configuration/services/${service.id}`}>{service.name}<br></br></Link>
                                ))}
                              </td>
                              <td className="center-cell">
                                <input className="column" type="checkbox" data-name={person.name} name={person.id} checked={person_ids.includes(person.id)} onChange={this.handleMultiCheckbox} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {peopleLoaded === false ? (
                          <div className="long-tr white-bg">
                            <div className="long-td">
                              Loading...
                            </div>
                          </div>
                        ) : (null)}
                    </div>

                    {this.renderPageButtons(page)}
                  </div>
                </div>
              </div>
            </div>

            <div className="settings big-settings">
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>

          {this.props.mode === "update" && <Audits klass="Service" id={this.props.id} /> }
        </div>
      );
    }
  }

  componentDidMount() {
    if (this.props.mode === "create") {
      request('GET', '/v1/a/services/next_default_color', null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            color: data.color,
            color_hex: data.color,
            text_color: getContrastYIQ(data.color),
            loaded: true
          })
        })
        .catch(error => {
          handleRequestErrors(this, error, { loaded: true })
        })
    }
    else {
      request('GET', `/v1/a/services/${this.props.id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            name: data.name,
            color: data.color,
            color_hex: data.color,
            text_color: getContrastYIQ(data.color),
            default_price: data.default_price,
            duration: data.duration,
            staff_breaks: data.staff_breaks || [],
            person_ids: data.person_ids,
            service_category_id: data.service_category_id || "",
            hidden: data.hidden,
            loaded: true
          })
        })
        .catch(error => {
          handleRequestErrors(this, error, { loaded: true })
        })
    }

    request('GET', `/v1/a/people/scoped_names_and_ids?person[type][]=staff&page=${this.state.page}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        handleRequestErrors(this, error, { peopleLoaded: true })
      })

    request('GET', `/v1/a/organisations/0`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        let durationOptions;
        if (data.slot_length) {
          // As many options as needed to get to at least 3 Hours as a maximum
          const optionsLength = Math.ceil(180/data.slot_length)
          durationOptions = []
          for (let i = 0; i < optionsLength; i++) {
            const minutes = (i + 1) * data.slot_length
            durationOptions.push(<option key={i} value={minutes}>{minutes} minute{minutes > 1 ? "s" : ""} </option>)
          }
        }

        this.setState({ slotLength: data.slot_length, durationOptions: durationOptions, slotLengthLoaded: true })
      })
      .catch(error => {
        handleRequestErrors(this, error, { slotLengthLoaded: true })
      })

    request('GET', '/v1/a/service_categories/names_and_ids', null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ service_categories: data, serviceCategoriesLoaded: true })
      })
      .catch(error => {
        handleRequestErrors(this, error, { serviceCategoriesLoaded: true })
      })
  }
}

export default ServiceForm;
